import { Accessory } from "features/accessories/types";
import { Product } from "features/ProductReel/types";
import React from "react";
import { Helmet } from "react-helmet";
import { resolveEuroPrice } from "features/utils";
interface Props {
  item: Product | Accessory;
}
const HeadMeta: React.FC<Props> = ({ item }) => {
  return (
    <Helmet>
      {item?.titleMeta && <title>{item?.titleMeta}</title>}
      {item?.descriptionMeta && (
        <meta name="description" content={item.descriptionMeta} />
      )}
      {item?.tagsMeta && <meta property="keywords" content={item?.tagsMeta} />}
      <meta property="og:title" content={item?.title} />
      {/* <meta property="og:description" content="Инверторен климатик Vivax ACP-12CH35AERI R Design с висока сезонна ефективност, еко и турбо режими, сензор I-Feel и др." /> */}
      <meta
        property="og:site_name"
        content="i-Clima.com - И КЛИМА ЕООД Карлово"
      />
      <meta property="og:url" content={window.location.toString()} />
      <meta
        property="og:image"
        content="https://5.imimg.com/data5/QL/AW/BE/ANDROID-18543253/product-jpeg-500x500.jpg"
      />
      <meta property="og:image:width" content="500" />
      <meta property="og:image:height" content="500" />
      <meta
        property="product:price:amount"
        content={resolveEuroPrice(
          item.price_promotion ? item.price_promotion : item.price,
          item.price_promotion ? item.price_promotion_eur : item.price_eur
        ).toFixed(2)}
      />
      <meta property="product:price:currency" content="EUR" />
      <meta property="og:type" content="product" />
    </Helmet>
  );
};

export default HeadMeta;
